import { Link } from 'react-router-dom';
import _ from 'lodash';
import { moment, splitTime } from 'utils/fmt';

//FIXME: webpack 설정?
if (!String.prototype.padStart) {
  // eslint-disable-next-line no-extend-native
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

if (!String.prototype.padEnd) {
  // eslint-disable-next-line no-extend-native
  String.prototype.padEnd = function padEnd(targetLength, padString) {
    targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return String(this) + padString.slice(0, targetLength);
    }
  };
}

export const ErrorString = {
  CheckIdFormat: '6~20자의 영문 소문자와 숫자만 사용 가능합니다.',
  CheckPasswordFormat: '영문과 숫자를 조합한 8~20자의 비밀번호를 입력해야합니다.',
  CheckPasswordConfirmFormat: '비밀번호가 일치하지 않습니다.',
  CheckEmailFormat: '이메일 형식을 확인해 주세요.',
  OnlyNumbersAreAllowed: '숫자만 입력 가능합니다.',
  CheckMobileNumber: '휴대폰 번호를 확인해주세요.',
  CheckAuthMobile: '휴대폰 인증이 필요합니다.',
  CheckAuthNumber: '인증번호가 일치하지 않습니다.',
  CheckTerms: '이용약관과 개인정보 동의가 필요합니다.',
  TryMobileAuth: '휴대폰 번호 인증이 필요합니다.',
  CheckRequiredValue: '모든 정보를 입력하셔야 회원가입이 가능합니다.',
  CheckUserNick: '별칭은 영문 4자, 한글 2자 이상 입력해주세요.',
  ErrorInToken: '로그인에 문제가 있습니다. (토큰오류)',
  IsNotOpeningHours: '지금은 영업시간이 아닙니다.',
};

export const fetchAsync = async (url) => {
  try {
    let response = await fetch(url);
    let data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
  }
  return null;
};

export const renderBlank = () => {
  return null;
};

export const showGraphQLError = (err) => {
  let errorMsg = err.message.toString();
  errorMsg = errorMsg.replace('GraphQL error: ', '');
  alert(errorMsg);
};

/**
 * 토큰 가져오기
 */
export const getToken = () => {
  let token = localStorage.getItem('token');
  if (token && token.length > 100) {
    return token;
  } else if (!token) {
    return null;
  } else {
    throw new Error(ErrorString.ErrorInToken);
  }
};

/**
 * 토큰 설정
 * @param {object} signInOwner
 */
export const setTokenFromSignInOwner = (signInOwner) => {
  console.log('setTokenFromSignInOwner', signInOwner);
  let token = signInOwner.token;
  if (token && token.length > 100) {
    window.localStorage.setItem('token', signInOwner.token);
    window.localStorage.setItem('ownerNo', signInOwner.owner.ownerNo);
    window.localStorage.setItem('ownerId', signInOwner.owner.ownerId);
  } else {
    throw new Error(ErrorString.ErrorInToken);
  }
};

/**
 * 선택되어 있는 상점 아이디 설정
 * @param {object} shopId
 */
export const setCurrentShopInfo = (shopInfo) => {
  // console.log('setCurrentShopInfo :: ', JSON.stringify(shopInfo, null, 2));
  if (shopInfo) {
    window.sessionStorage.setItem('currentShopInfo', JSON.stringify(shopInfo, null, 2));
  } else {
    throw new Error(ErrorString.ErrorInToken);
  }
};

/**
 * 선택되어 있는 상점 아이디 반환
 * @param {object} shopId
 * @returns {object} currentShopInfo
 */
export const getCurrentShopInfo = () => {
  const currentShopInfo = window.sessionStorage.getItem('currentShopInfo');
  if (currentShopInfo) {
    // console.log('getcurrentShopInfo', JSON.parse(currentShopInfo, null, 2));
    return JSON.parse(currentShopInfo, null, 2);
  }
  return null;
};

/**
 * 토큰 설정
 * @param {object} createUserInfo
 */
export const setTokenFromCreateUserInfo = (createUserInfo) => {
  console.log('setTokenFromCreateUserInfo', createUserInfo);
  let token = createUserInfo.token;
  if (token && token.length > 100) {
    window.localStorage.setItem('token', createUserInfo.token);
    window.localStorage.setItem('userNo', createUserInfo.user.userNo);
    window.localStorage.setItem('userEmail', createUserInfo.user.email);
    window.localStorage.setItem('userNick', createUserInfo.user.nick);
  } else {
    throw new Error(ErrorString.ErrorInToken);
  }
};

/**
 * 토큰 지우기
 */
export const clearToken = () => {
  console.log('clearToken');
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('userNo');
  window.localStorage.removeItem('userEmail');
  window.localStorage.removeItem('userNick');
};

/**
 * todaysBizday 를 입력받아 영업 시간인지 여부를 반환 한다.
 * @param {object} todaysBizday  todaysBizday쿼리 결과
 * @return {boolean} 영업 중 여부 (true:영업, false:휴무일 or 휴게시간)
 */
export const getIsShopEnabled = (todaysBizdayArr) => {
  //TODO: 정리
  let isShopEnabled = false;
  if (todaysBizdayArr) {
    const yesterday = todaysBizdayArr[0];
    const todaysBizday = todaysBizdayArr[1];
    if (todaysBizday) {
      isShopEnabled = true;
      if (!todaysBizday.bizDayYn) {
        // 영업일이 아닌 경우
        // 금일은 휴무일입니다.
      } else if (todaysBizday.twentyFourBizYn) {
        // 운영시간 : 24시간 영업
      } else {
        if (todaysBizday.bizStTm) {
          const now = moment();

          const bizStartTime = moment();
          const bizEndTime = moment();

          const bizStartTimeObj = splitTime(todaysBizday.bizStTm);
          const bizEndTimeObj = splitTime(todaysBizday.bizEndTm);
          bizStartTime.set({ ...bizStartTimeObj });

          let variables = { ...bizEndTimeObj };
          if (bizEndTimeObj.hour >= 24) {
            // 시간 설정이 0부터 36까지 가능하기 때문에 24시 이상의 경우에는 날짜 변환 필요
            variables.hour -= 24;
            bizEndTime.set(variables);
            bizEndTime.add(1, 'days');
          } else {
            bizEndTime.set(variables);
          }

          isShopEnabled = now.isBetween(bizStartTime, bizEndTime);
          if (isShopEnabled && todaysBizday.restTmYn) {
            // 24시간 영업이 아니고, 휴게 시간이 있는 경우
            const restStartTimeObj = splitTime(todaysBizday.restStTm);
            const restEndTimeObj = splitTime(todaysBizday.restEndTm);

            let restStartTime = bizStartTime;
            let restEndTime = bizEndTime;
            restStartTime.set({ ...restStartTimeObj });
            restEndTime.set({ ...restEndTimeObj });
            isShopEnabled = !now.isBetween(bizStartTime, bizEndTime);
          }

          if (!isShopEnabled && now.isBefore(bizStartTime)) {
            // 하루 전 날짜의 영업시간에 현재 시간이 포함되는지 확인
            const yBizStartTimeObj = splitTime(yesterday.bizStTm);
            const yBizEndTimeObj = splitTime(yesterday.bizEndTm);
            const yBizStartTime = moment();
            const yBizEndTime = moment();

            yBizStartTime.set({ ...yBizStartTimeObj });
            let yVariables = { ...yBizEndTimeObj };

            if (yBizEndTimeObj.hour >= 24) {
              // 시간 설정이 0부터 36까지 가능하기 때문에 24시 이상의 경우에는 날짜 변환 필요
              yVariables.hour -= 24;
              yBizEndTime.set(yVariables);
              yBizEndTime.add(1, 'days');
            } else {
              yBizEndTime.set(yVariables);
            }

            yBizStartTime.subtract(1, 'days');
            yBizEndTime.subtract(1, 'days');
            isShopEnabled = now.isBetween(yBizStartTime, yBizEndTime);
          }
        }
      }
    }
  }

  // console.log(`getIsShopEnabled isShopEnabled :: ${isShopEnabled}`);
  return isShopEnabled;
};

let notificationAudio = null;

export const unlockNotificationSound = (soundFile = 'alarm.wav') => {
  if (notificationAudio) return;

  notificationAudio = new Audio(soundFile);
  notificationAudio.muted = true;
  notificationAudio.play()
    .then(() => {
      notificationAudio.pause();
      notificationAudio.currentTime = 0;
      notificationAudio.muted = false;
    })
    .catch(() => {
      notificationAudio = null;
    });
};

export const makeNotification = (appIcon, title, description, soundFile = 'alarm.wav') => {
  if (!notificationAudio) {
    notificationAudio = new Audio(soundFile);
  }

  notificationAudio.currentTime = 0;
  notificationAudio.play().catch((error) => console.warn('알림 사운드 재생 실패:', error));

  if (!('Notification' in window) || window.Notification.permission !== 'granted') {
    return null;
  }

  const notification = new window.Notification(title, {
    body: description,
    icon: appIcon,
  });

  // setTimeout(function () {
  //   notification.close();
  // }, 2000);

  return notification;
};
